(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["media-with-text-overlay"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const currentURL = window.location.href;

  if (currentURL.match('products')) {
    const element = document.querySelector('.media-with-text-overlay .button__text');
    
    if (element) {
      element.classList.remove("text-weight--")
      element.classList.add('text-weight--extra-bold');
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const currentURL = window.location.href;

  if (currentURL.match('products')) {
    const element = document.querySelector('form[action*="/contact#newsletter-sections"] button span');

    console.log(element)
    
    if (element) {
      element.classList.remove("text-weight--")
      element.classList.add('text-weight--extra-bold');
    }
  }
});

  } catch(e) { console.error(e); }
})();

})();
